export const USER_PASSWORD_UPDATE = '/account/signup/';
